module.exports = __webpack_public_path__ + "static/media/silence.eca6a3a0.mp3";